// @core/stores/booking/BookingBookingNumberingStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { bookingApi } from '@core/api';
import type {
  BookingNumberingSchemeResponse,
  CreateBookingNumberingSchemeRequest,
  ListBookingNumberingSchemesResponse,
  UpdateBookingNumberingSchemeRequest,
} from '@core/types/booking';

class BookingBookingNumberingStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Create numbering scheme
   */
  async CreateBookingNumberingScheme(data: CreateBookingNumberingSchemeRequest): Promise<BookingNumberingSchemeResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.CreateBookingNumberingScheme(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Delete numbering scheme
   */
  async DeleteBookingNumberingScheme(scheme_id: string): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.DeleteBookingNumberingScheme(scheme_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get numbering scheme
   */
  async GetBookingNumberingScheme(scheme_id: string): Promise<BookingNumberingSchemeResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.GetBookingNumberingScheme(scheme_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * List numbering schemes
   */
  async ListBookingNumberingSchemes(params?: { limit?: string | number | boolean; cursor?: string | number | boolean; direction?: string | number | boolean; sort?: string | number | boolean; }): Promise<ListBookingNumberingSchemesResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.ListBookingNumberingSchemes(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Update numbering scheme
   */
  async UpdateBookingNumberingScheme(scheme_id: string, data: UpdateBookingNumberingSchemeRequest): Promise<BookingNumberingSchemeResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.UpdateBookingNumberingScheme(scheme_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const bookingBookingNumberingStore = new BookingBookingNumberingStore();
